import ChartManager  from './chart-manager';

export default ChartManager;
